function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module editor-inline/inlineeditoruiview
 */
import { BalloonPanelView, EditorUIView, InlineEditableUIView, ToolbarView } from 'ckeditor5/src/ui';
import { Rect, ResizeObserver, toUnit } from 'ckeditor5/src/utils';
var toPx = toUnit('px');
/**
 * Inline editor UI view. Uses an nline editable and a floating toolbar.
 *
 * @extends module:ui/editorui/editoruiview~EditorUIView
 */

var InlineEditorUIView =
/*#__PURE__*/
function (_EditorUIView) {
  _inherits(InlineEditorUIView, _EditorUIView);

  /**
   * Creates an instance of the inline editor UI view.
   *
   * @param {module:utils/locale~Locale} locale The {@link module:core/editor/editor~Editor#locale} instance.
   * @param {module:engine/view/view~View} editingView The editing view instance this view is related to.
   * @param {HTMLElement} [editableElement] The editable element. If not specified, it will be automatically created by
   * {@link module:ui/editableui/editableuiview~EditableUIView}. Otherwise, the given element will be used.
   * @param {Object} [options={}] Configuration options for the view instance.
   * @param {Boolean} [options.shouldToolbarGroupWhenFull] When set `true` enables automatic items grouping
   * in the main {@link module:editor-inline/inlineeditoruiview~InlineEditorUIView#toolbar toolbar}.
   * See {@link module:ui/toolbar/toolbarview~ToolbarOptions#shouldGroupWhenFull} to learn more.
   */
  function InlineEditorUIView(locale, editingView, editableElement) {
    var _this;

    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck(this, InlineEditorUIView);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InlineEditorUIView).call(this, locale));
    /**
     * A floating toolbar view instance.
     *
     * @readonly
     * @member {module:ui/toolbar/toolbarview~ToolbarView}
     */

    _this.toolbar = new ToolbarView(locale, {
      shouldGroupWhenFull: options.shouldToolbarGroupWhenFull,
      isFloating: true
    });
    /**
     * The offset from the top edge of the web browser's viewport which makes the
     * UI become sticky. The default value is `0`, which means that the UI becomes
     * sticky when its upper edge touches the top of the page viewport.
     *
     * This attribute is useful when the web page has UI elements positioned to the top
     * either using `position: fixed` or `position: sticky`, which would cover the
     * UI or vice–versa (depending on the `z-index` hierarchy).
     *
     * @readonly
     * @observable
     * @member {Number} #viewportTopOffset
     */

    _this.set('viewportTopOffset', 0);
    /**
     * A balloon panel view instance.
     *
     * @readonly
     * @member {module:ui/panel/balloon/balloonpanelview~BalloonPanelView}
     */


    _this.panel = new BalloonPanelView(locale);
    _this.panel.withArrow = false;
    /**
     * A set of positioning functions used by the {@link #panel} to float around
     * {@link #element editableElement}.
     *
     * The positioning functions are as follows:
     *
     * * West:
     *
     *		[ Panel ]
     *		+------------------+
     *		| #editableElement |
     *		+------------------+
     *
     *		+------------------+
     *		| #editableElement |
     *		|[ Panel ]         |
     *		|                  |
     *		+------------------+
     *
     *		+------------------+
     *		| #editableElement |
     *		+------------------+
     *		[ Panel ]
     *
     * * East:
     *
     *		           [ Panel ]
     *		+------------------+
     *		| #editableElement |
     *		+------------------+
     *
     *		+------------------+
     *		| #editableElement |
     *		|         [ Panel ]|
     *		|                  |
     *		+------------------+
     *
     *		+------------------+
     *		| #editableElement |
     *		+------------------+
     *		           [ Panel ]
     *
     * See: {@link module:utils/dom/position~Options#positions}.
     *
     * @readonly
     * @type {Array.<Function>}
     */

    _this.panelPositions = _this._getPanelPositions();

    _this.panel.extendTemplate({
      attributes: {
        "class": 'ck-toolbar-container'
      }
    });
    /**
     * Editable UI view.
     *
     * @readonly
     * @member {module:ui/editableui/inline/inlineeditableuiview~InlineEditableUIView}
     */


    _this.editable = new InlineEditableUIView(locale, editingView, editableElement);
    /**
     * An instance of the resize observer that helps dynamically determine the geometry of the toolbar
     * and manage items that do not fit into a single row.
     *
     * **Note:** Created in {@link #render}.
     *
     * @private
     * @member {module:utils/dom/resizeobserver~ResizeObserver}
     */

    _this._resizeObserver = null;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(InlineEditorUIView, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      _get(_getPrototypeOf(InlineEditorUIView.prototype), "render", this).call(this);

      this.body.add(this.panel);
      this.registerChild(this.editable);
      this.panel.content.add(this.toolbar);
      var options = this.toolbar.options; // Set toolbar's max-width on the initialization and update it on the editable resize,
      // if 'shouldToolbarGroupWhenFull' in config is set to 'true'.

      if (options.shouldGroupWhenFull) {
        var editableElement = this.editable.element;
        this._resizeObserver = new ResizeObserver(editableElement, function () {
          _this2.toolbar.maxWidth = toPx(new Rect(editableElement).width);
        });
      }
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(InlineEditorUIView.prototype), "destroy", this).call(this);

      if (this._resizeObserver) {
        this._resizeObserver.destroy();
      }
    }
    /**
     * Determines the panel top position of the {@link #panel} in {@link #panelPositions}.
     *
     * @private
     * @param {module:utils/dom/rect~Rect} editableRect Rect of the {@link #element}.
     * @param {module:utils/dom/rect~Rect} panelRect Rect of the {@link #panel}.
     */

  }, {
    key: "_getPanelPositionTop",
    value: function _getPanelPositionTop(editableRect, panelRect) {
      var top;

      if (editableRect.top > panelRect.height + this.viewportTopOffset) {
        top = editableRect.top - panelRect.height;
      } else if (editableRect.bottom > panelRect.height + this.viewportTopOffset + 50) {
        top = this.viewportTopOffset;
      } else {
        top = editableRect.bottom;
      }

      return top;
    }
    /**
     * Returns the positions for {@link #panelPositions}.
     *
     * See: {@link module:utils/dom/position~Options#positions}.
     *
     * @private
     * @returns {Array.<Function>}
     */

  }, {
    key: "_getPanelPositions",
    value: function _getPanelPositions() {
      var _this3 = this;

      var positions = [function (editableRect, panelRect) {
        return {
          top: _this3._getPanelPositionTop(editableRect, panelRect),
          left: editableRect.left,
          name: 'toolbar_west'
        };
      }, function (editableRect, panelRect) {
        return {
          top: _this3._getPanelPositionTop(editableRect, panelRect),
          left: editableRect.left + editableRect.width - panelRect.width,
          name: 'toolbar_east'
        };
      }];

      if (this.locale.uiLanguageDirection === 'ltr') {
        return positions;
      } else {
        return positions.reverse();
      }
    }
  }]);

  return InlineEditorUIView;
}(EditorUIView);

export { InlineEditorUIView as default };